import React from "react";
import { connect } from "react-redux";
import { LOGOUT } from "../constants/actionTypes";

const mapDispatchToProps = dispatch => ({
    logout: () => dispatch({type: LOGOUT})
});

class Logout extends React.Component {
    componentWillMount() {
        this.props.logout();
    }

    render() {
        return (
            <div>Досвиданья!</div>
        );
    }
}

export default connect(undefined, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout.js